import React from 'react';
import './UniversalSkeleton.css';

function UniversalSkeleton({ fullWidth = false }) {
  // Add class conditionally based on fullWidth prop
  const containerClass = fullWidth 
    ? "universal-skeleton full-width" 
    : "universal-skeleton";

  return (
    <div className={containerClass}>
      {/* Item 1 - Large header with content */}
      <div className="universal-skeleton-item">
        <div className="skeleton-header">
          <div className="skeleton-circle shimmer large" />
          <div className="skeleton-header-lines">
            <div className="skeleton-line shimmer" style={{ width: '65%' }} />
            <div className="skeleton-line shimmer small" style={{ width: '35%' }} />
          </div>
        </div>
        <div className="skeleton-content">
          <div className="skeleton-line shimmer" />
          <div className="skeleton-line shimmer" style={{ width: '95%' }} />
          <div className="skeleton-line shimmer" style={{ width: '80%' }} />
          <div className="skeleton-line shimmer" style={{ width: '70%' }} />
          <div className="skeleton-line shimmer" style={{ width: '95%' }} />
          <div className="skeleton-line shimmer" style={{ width: '80%' }} />
          <div className="skeleton-line shimmer" style={{ width: '70%' }} />
        </div>
      </div>
      
      {/* Item 2 - Medium content block */}
      <div className="universal-skeleton-item">
        <div className="skeleton-content">
          <div className="skeleton-line shimmer title" style={{ width: '45%' }} />
          <div className="skeleton-line shimmer" />
          <div className="skeleton-line shimmer" style={{ width: '88%' }} />
          <div className="skeleton-line shimmer" style={{ width: '65%' }} />
        </div>
      </div>
      
      {/* Item 3 - Compact with avatar */}
      <div className="universal-skeleton-item">
        <div className="skeleton-row">
          <div className="skeleton-circle shimmer" />
          <div className="skeleton-lines">
            <div className="skeleton-line shimmer" style={{ width: '75%' }} />
            <div className="skeleton-line shimmer small" style={{ width: '45%' }} />
          </div>
        </div>
      </div>
      
      {/* Item 4 - Full content with smaller avatar */}
      <div className="universal-skeleton-item">
        <div className="skeleton-header">
          <div className="skeleton-circle shimmer" />
          <div className="skeleton-header-lines">
            <div className="skeleton-line shimmer" style={{ width: '55%' }} />
            <div className="skeleton-line shimmer small" style={{ width: '40%' }} />
          </div>
        </div>
        <div className="skeleton-content">
          <div className="skeleton-line shimmer" style={{ width: '100%' }} />
          <div className="skeleton-line shimmer" style={{ width: '85%' }} />
          <div className="skeleton-line shimmer" style={{ width: '60%' }} />
        </div>
      </div>
      
      {/* Item 5 - Simple content lines */}
      <div className="universal-skeleton-item">
        <div className="skeleton-content">
          <div className="skeleton-line shimmer" style={{ width: '100%' }} />
          <div className="skeleton-line shimmer" style={{ width: '92%' }} />
          <div className="skeleton-line shimmer" style={{ width: '78%' }} />
          <div className="skeleton-line shimmer" style={{ width: '55%' }} />
        </div>
      </div>
      
      {/* Item 6 - Compact row variant */}
      <div className="universal-skeleton-item">
        <div className="skeleton-row">
          <div className="skeleton-circle shimmer small" />
          <div className="skeleton-lines">
            <div className="skeleton-line shimmer" style={{ width: '80%' }} />
            <div className="skeleton-line shimmer small" style={{ width: '50%' }} />
            <div className="skeleton-line shimmer small" style={{ width: '30%' }} />
          </div>
        </div>
      </div>
        {/* Item 1 - Large header with content */}
        <div className="universal-skeleton-item">
        <div className="skeleton-header">
          <div className="skeleton-circle shimmer large" />
          <div className="skeleton-header-lines">
            <div className="skeleton-line shimmer" style={{ width: '65%' }} />
            <div className="skeleton-line shimmer small" style={{ width: '35%' }} />
          </div>
        </div>
        <div className="skeleton-content">
          <div className="skeleton-line shimmer" />
          <div className="skeleton-line shimmer" style={{ width: '95%' }} />
          <div className="skeleton-line shimmer" style={{ width: '80%' }} />
          <div className="skeleton-line shimmer" style={{ width: '70%' }} />
          <div className="skeleton-line shimmer" style={{ width: '95%' }} />
          <div className="skeleton-line shimmer" style={{ width: '80%' }} />
          <div className="skeleton-line shimmer" style={{ width: '70%' }} />
        </div>
      </div>
      
    </div>
  );
}

export default UniversalSkeleton;